import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Event handler function type.
 */

/**
 * Event filter predicate function type.
 */

/**
 * Configuration options for the event emitter.
 */

/**
 * Event subscription handle for managing listeners.
 */

/**
 * Core event emitter for bridge API events.
 *
 * This emitter is designed to be lightweight and performant, with minimal
 * overhead when events are not being consumed. All events are domain events,
 * with the intent of enabling loosely coupled internal systems which observe
 * the entire bridge API. E.g., our debugging sub-system.
 */
export var BridgeEventEmitter = /*#__PURE__*/function () {
  function BridgeEventEmitter() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, BridgeEventEmitter);
    _defineProperty(this, "handlers", new Map());
    _defineProperty(this, "globalHandlers", new Set());
    _defineProperty(this, "eventHistory", []);
    _defineProperty(this, "bridgeId", null);
    this.config = _objectSpread({
      enabled: true,
      maxHistorySize: 1000,
      captureHistory: true
    }, config);
  }

  /**
   * Set the bridge ID for this emitter instance.
   * Should be called once when the bridge API is initialized.
   *
   * @param bridgeId The unique identifier for the bridge API instance
   */
  return _createClass(BridgeEventEmitter, [{
    key: "setBridgeId",
    value: function setBridgeId(bridgeId) {
      this.bridgeId = bridgeId;
    }

    /**
     * Emit an event to all registered handlers.
     * Automatically adds timestamp and bridge ID to the event.
     *
     * @param event The event to emit (without timestamp and bridgeId)
     */
  }, {
    key: "emit",
    value: function emit(event) {
      var _this$bridgeId;
      // Early return if emitter is disabled
      if (!this.config.enabled) {
        return;
      }

      // Automatically add timestamp and bridge ID
      var fullEvent = _objectSpread(_objectSpread({}, event), {}, {
        timestamp: Date.now(),
        bridgeId: (_this$bridgeId = this.bridgeId) !== null && _this$bridgeId !== void 0 ? _this$bridgeId : 'unknown-bridge'
      });

      // Add to history if enabled
      if (this.config.captureHistory) {
        this.addToHistory(fullEvent);
      }

      // Emit to type-specific handlers
      var typeHandlers = this.handlers.get(fullEvent.type);
      if (typeHandlers) {
        var _iterator = _createForOfIteratorHelper(typeHandlers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var handler = _step.value;
            this.safeInvoke(handler, fullEvent);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      // Emit to global handlers
      var _iterator2 = _createForOfIteratorHelper(this.globalHandlers),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _handler = _step2.value;
          this.safeInvoke(_handler, fullEvent);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }

    /**
     * Listen for events of a specific type.
     *
     * @param eventType The type of event to listen for
     * @param handler The handler function to call when the event occurs
     * @returns A subscription handle
     */
  }, {
    key: "on",
    value: function on(eventType, handler) {
      var _this = this;
      if (!this.handlers.has(eventType)) {
        this.handlers.set(eventType, new Set());
      }
      var handlers = this.handlers.get(eventType);
      handlers.add(handler);
      return this.createSubscription(function () {
        handlers.delete(handler);
        if (handlers.size === 0) {
          _this.handlers.delete(eventType);
        }
      });
    }

    /**
     * Listen for all events regardless of type.
     *
     * @param handler The handler function to call for any event
     * @returns A subscription handle
     */
  }, {
    key: "onAny",
    value: function onAny(handler) {
      var _this2 = this;
      this.globalHandlers.add(handler);
      return this.createSubscription(function () {
        _this2.globalHandlers.delete(handler);
      });
    }

    /**
     * Remove a specific handler for an event type.
     *
     * @param eventType The event type to remove the handler from
     * @param handler The handler to remove
     */
  }, {
    key: "off",
    value: function off(eventType, handler) {
      var handlers = this.handlers.get(eventType);
      if (handlers) {
        handlers.delete(handler);
        if (handlers.size === 0) {
          this.handlers.delete(eventType);
        }
      }
    }

    /**
     * Remove all handlers for a specific event type.
     *
     * @param eventType The event type to clear handlers for
     */
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(eventType) {
      if (eventType) {
        this.handlers.delete(eventType);
      } else {
        this.handlers.clear();
        this.globalHandlers.clear();
      }
    }

    /**
     * Get the current event history.
     *
     * @returns Array of events in chronological order
     */
  }, {
    key: "getHistory",
    value: function getHistory() {
      return _toConsumableArray(this.eventHistory);
    }

    /**
     * Get events from history that match a filter.
     *
     * @param filter Predicate function to filter events
     * @returns Array of matching events
     */
  }, {
    key: "getFilteredHistory",
    value: function getFilteredHistory(filter) {
      return this.eventHistory.filter(function (e) {
        return filter(e);
      });
    }

    /**
     * Clear the event history.
     */
  }, {
    key: "clearHistory",
    value: function clearHistory() {
      this.eventHistory = [];
    }

    /**
     * Update emitter configuration.
     *
     * @param config New configuration options
     */
  }, {
    key: "configure",
    value: function configure(config) {
      this.config = _objectSpread(_objectSpread({}, this.config), config);

      // Trim history if max size was reduced
      if (this.eventHistory.length > this.config.maxHistorySize) {
        this.eventHistory = this.eventHistory.slice(-this.config.maxHistorySize);
      }
    }

    /**
     * Enable or disable the emitter.
     *
     * @param enabled Whether to enable event emission
     */
  }, {
    key: "setEnabled",
    value: function setEnabled(enabled) {
      this.config.enabled = enabled;
    }

    /**
     * Check if the emitter is currently enabled.
     */
  }, {
    key: "isEnabled",
    value: function isEnabled() {
      return this.config.enabled;
    }

    /**
     * Destroy the emitter and clean up all resources.
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.handlers.clear();
      this.globalHandlers.clear();
      this.eventHistory = [];
      this.config.enabled = false;
    }

    /**
     * Add an event to the history, managing size limits.
     */
  }, {
    key: "addToHistory",
    value: function addToHistory(event) {
      this.eventHistory.push(event);

      // Trim history if it exceeds max size
      if (this.eventHistory.length > this.config.maxHistorySize) {
        this.eventHistory.shift();
      }
    }

    /**
     * Safely invoke a handler, catching any errors.
     */
  }, {
    key: "safeInvoke",
    value: function safeInvoke(handler, event) {
      try {
        handler(event);
      } catch (_unused) {
        // we do not want to produce error logs for the observer
        // if you need to add logs, go for it - just remove them afterwards!
      }
    }

    /**
     * Create a subscription handle.
     */
  }, {
    key: "createSubscription",
    value: function createSubscription(unsubscribeFn) {
      var active = true;
      return {
        unsubscribe: function unsubscribe() {
          if (active) {
            unsubscribeFn();
            active = false;
          }
        },
        isActive: function isActive() {
          return active;
        }
      };
    }
  }]);
}();

/**
 * Default global event emitter instance.
 *
 * This can be used as a singleton across the bridge API, or individual
 * bridge instances can create their own emitters.
 */
var globalEmitter = null;

/**
 * Get or create the global event emitter instance.
 */
export function emitter() {
  if (!globalEmitter) {
    globalEmitter = new BridgeEventEmitter();
  }
  return globalEmitter;
}

/**
 * Destroy the global event emitter instance.
 */
export function destroyGlobalEventEmitter() {
  if (globalEmitter) {
    globalEmitter.destroy();
    globalEmitter = null;
  }
}